const hasLetters = (str) => {
  return /[a-zA-Z]/.test(str);
};

export const formatPhoneNumber = ({
  phoneNumber,
  format,
  placeholder,
  prefix = null,
  withCode = false,
}) => {
  if (typeof phoneNumber !== 'string') {
    throw new Error('Неверный тип: номер телефона должен быть строкой');
  }

  let phone = phoneNumber;

  if (hasLetters(phoneNumber)) {
    return phoneNumber;
  }

  if (!phone || phone.trim().length === 0) return;

  phone = phone.replace(/\D/g, '');

  if (phone.length > 10 && (phone.startsWith('7') || phone.startsWith('8'))) {
    phone = phone.slice(1);
  }

  if (!format) {
    return withCode ? `+7${phone}` : prefix ? `${prefix}${phone}` : phone;
  }

  let formattedNumber = '';
  let index = 0;

  for (let char of format) {
    if (char === placeholder) {
      formattedNumber += phone[index];
      index++;
    } else {
      if (phone[index + 1]) {
        formattedNumber += char;
      } else {
        break;
      }
    }
  }

  return withCode
    ? `+7 ${formattedNumber}`
    : prefix
    ? `${prefix}${formattedNumber}`
    : formattedNumber;
};
